$(document).ready(function() {
    $('.pricing_t3_buy_buttons').on('click', function(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      var $form = $(this).closest('form');
      var product_id = $form.find('input[name="product-id"]').val();
      addtocart(product_id, $form);
      $(this).prop('disabled', true).text("Checking Out...");
    });
});
function addtocart(product_id, form){
    //$('.pricing_t3_buy_buttons').prop('disabled', true).text("Checking Out...");

    // Clear the cart
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => response.json())
    .then(async () => {
      console.log('Cart cleared');

      // Get the product form data
      const formData = new FormData(form.get(0));

      // Add the selected product to the cart
      await fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({
          items: [
            {
              id: product_id,
              quantity: 1
            }
          ]
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Add the original product to the cart
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then(response => response.json())
      .then(data => {
        console.log("Product added to cart", data);
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error:', error);
      });
    })
    .catch(error => console.error('Error clearing cart:', error));
  }